import { useQuery } from "react-query";
import { axiosClient } from "../services/axiosInstance";

const useGetLevelAcademic = () => {
  const data = useQuery(["getLevelAcademic"], () =>
    axiosClient.post(`Setting/GepSettingList?groupSettingId=26`)
  );
  return data;
};
export default useGetLevelAcademic;
